import React, { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { FileUploadRequestData, findUploaded, uploadFile } from '../../fileSlice';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { useAuth } from 'react-oidc-context';
import { isFulfilled } from '@reduxjs/toolkit';
import styled from 'styled-components';

const getColor = (props: any) => {
  if (props.$isDragAccept) {
      return '#00e676';
  }
  if (props.$isDragReject) {
      return '#ff1744';
  }
  if (props.$isFocused) {
      return '#2196f3';
  }
  return '#eeeeee';
}

const Container = styled.div<{$show: boolean}>`
  position: absolute;
  left: 50%;
  flex: 1;
  display: ${props => props.$show ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${props => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border .24s ease-in-out;
  z-index: 200;
`;

interface FileUploaderProps {
  openDialogue: boolean
  setOpenDialogue: React.Dispatch<React.SetStateAction<boolean>>
  selectedFile: string
  setSelectedFile: React.Dispatch<React.SetStateAction<string>>
}
export const FileUploader = (props: FileUploaderProps) => {
  // general redux
  const auth = useAuth();
  const dispatch = useAppDispatch();

  // file upload

  const uploadImageCallBack = async (file: File)  => {
      
    const action = await dispatch(uploadFile({ 
      accessToken: auth.user?.access_token, 
      referer: 'exhibit', contentType: file.type, fileName: file.name, file: file } as FileUploadRequestData));

    if (isFulfilled(action)) {
      console.log(action.payload)
      //let {payload} = dispatch(findUploaded(file.name));
      console.log(action.payload);
      props.setSelectedFile(action.payload.url);
    }
  }
  

  useEffect(() => {
    // this will have its effect only when the prop value changes
    // which is when Toolbar detects the onMouseDown event on the image button
    props.setOpenDialogue(props.openDialogue);
    
  },[props,props.openDialogue])

  

  const onDrop = useCallback((acceptedFiles: any[]) => {

    acceptedFiles.forEach((file: any) => {
      const reader = new FileReader()

      reader.onload = async () => await uploadImageCallBack(file);

      reader.readAsArrayBuffer(file)
    })
  }, [])

  const { getRootProps, getInputProps, acceptedFiles, isFocused, isDragAccept, isDragReject } = useDropzone({ onDrop })

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));


  return (
    <div className="container">
      <Container {...getRootProps({$isFocused:isFocused, $isDragAccept:isDragAccept, $isDragReject:isDragReject})} $show ={props.openDialogue} onClick={e => e.stopPropagation()}>
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          <p>Drag 'n' drop some files here, or click to select files</p>
        </div>
        <aside>
          <h4>Files</h4>
          <ul>{files}</ul>
        </aside>
        <button type="button" onClick={() => props.setOpenDialogue(false)}>
          Done
        </button>
      </Container>
    </div>
  )
}


